import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import Vue from "vue";
const { version } = require("../../package.json");

export const initSentry = (router, store) => {
  try {
    console.log("开始初始化Sentry...");
    console.log("环境变量:", {
      NODE_ENV: process.env.NODE_ENV,
      VUE_APP_BUILD_ENV: process.env.VUE_APP_BUILD_ENV,
      VUE_APP_SAAS_WEB_URL: process.env.VUE_APP_SAAS_WEB_URL,
    });

    // 只在非开发环境或者明确指定生产环境时初始化Sentry
    if (process.env.NODE_ENV !== "development") {
      console.log("生产环境，初始化Sentry");
      Sentry.init({
        Vue,
        dsn: "https://b8c48dac6cb8df0fd544c5e4cea20642@sentry.upho2015.com/49",
        sendDefaultPii: true,
        environment: process.env.VUE_APP_BUILD_ENV || "production",
        debug: false, // 开启调试模式
        integrations: [
          new Integrations.BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: [
              "localhost",
              process.env.VUE_APP_SAAS_WEB_URL,
              /^\//,
            ],
          }),
        ],
        release: version,
        beforeSend(event) {
          // console.log("Sentry准备发送事件:", event);
          return event;
        },
        beforeBreadcrumb(breadcrumb) {
          // console.log("Sentry面包屑:", breadcrumb);
          return breadcrumb;
        },
      });

      // console.log("Sentry初始化成功");

      // 设置用户信息监听
      store.watch(
        (state, getters) => getters.isAuthenticated,
        (newValue, oldValue) => {
          console.log("initSentryWithStore2", store.getters.user);
          console.log("oldValue", oldValue);
          console.log("newValue", newValue);

          if (newValue && !oldValue) {
            // 用户登录
            const userInfo = store.getters.user;
            updateSentryUser(userInfo);
          } else if (!newValue && oldValue) {
            // 用户登出
            setSentryUser(null);
          }
        }
      );
    } else {
      console.log("开发环境，跳过Sentry初始化");
    }
  } catch (error) {
    console.error("Sentry初始化失败:", error);
  }
};
// 更新Sentry用户信息的辅助函数
function updateSentryUser(userInfo) {
  if (!userInfo || !userInfo.user_id) return;

  setSentryUser({
    id: userInfo.user_id,
    username: userInfo.nickname,
    name: userInfo.name,
  });

  // 设置额外的标签
  setSentryTag("user_role", userInfo.role_name || "normal");
}

export const setSentryUser = (user) => {
  Sentry.setUser({
    id: user?.id,
    username: user?.username,
    name: user?.name,
  });
};

export const setSentryTag = (key, value) => {
  Sentry.setTag(key, value);
};
